import Backbone from 'backbone';
import {formatDate} from 'common/formatters/date-formatter';
import {DateTimeFormat} from 'common/proxies/enum-proxy';
import {t} from 'common/utils/translation-util';

const TimestampView = Backbone.View.extend({
  render(collections) {
    const collection = collections[0];
    let timestamp = collection.getEndTimestamp();
    timestamp = formatDate(timestamp, DateTimeFormat.TEXTUAL_DAY_OF_WEEK);
    this.$el.html(t('Last updated: %(timestamp)s', {timestamp}));
  },
});

export default TimestampView;
